module.exports = __webpack_public_path__ + "static/media/tie.553673f8.svg";